import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: { affair_name?: string };
};

const AffairNameCell = React.memo((row: KpiWorkunitGridData) => {
  const affair = row.order?.affair_name ? row.order.affair_name.trim() : '';
  return (
    <Tooltip title={affair}>
      <Typography variant="body2" noWrap>
        {affair}
      </Typography>
    </Tooltip>
  );
});

export default AffairNameCell;
